(() => {
  const TRYON_TEXT = "- TRY ON";
  let debounceTimer = null;
  let fixingCart = false;

  function isTryOnItem(item) {
    const title = (item?.product_title || item?.title || "").toLowerCase();
    return title.includes(TRYON_TEXT.toLowerCase());
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }

  async function changeCartItem(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      const fmt = window.theme?.moneyFormat || window.Shopify.money_format || "${{amount}}";
      return window.Shopify.formatMoney(cents, fmt);
    }

    return `$${(cents / 100).toFixed(2)}`;
  }

  function findSubtotalNodes() {
    const selectors = [
      ".cart__recap [data-money]",
      ".cart__recap .money",
      ".cart__recap .h-stack .money",
      ".cart__recap .text-subdued .money",
      ".cart__recap .cart-recap__total .money",
      ".cart__recap .cart-recap__total [data-money]",
      "[data-cart-summary] [data-cart-subtotal]",
      "[data-cart-summary] .totals__subtotal-value",
      ".cart-summary [data-cart-subtotal]",
      ".cart-summary .totals__subtotal-value",
      ".totals__subtotal .money",
      ".totals__total .money",
      ".cart .money",
      ".cart [data-money]"
    ];

    const nodes = [];
    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => nodes.push(node));
    });

    return [...new Set(nodes)];
  }

  function isCartTotalNode(node) {
    const recap = node.closest(
      ".cart__recap, .cart-recap, .cart__footer, [data-cart-summary], .cart-summary, .totals"
    );

    if (!recap) return false;

    if (node.closest(".cart-item, .line-item, [data-line-item], .cart__items")) {
      return false;
    }

    return (recap.innerText || "").toLowerCase().includes("total");
  }

  function renderCrossout(node, originalCents, newCents) {
    if (!node.dataset.tryonOriginalHtml) {
      node.dataset.tryonOriginalHtml = node.innerHTML;
    }

    node.innerHTML = `
      <span class="tryon-total-wrap" style="display:inline-flex;gap:8px;align-items:baseline;justify-content:flex-end;">
        <s class="tryon-total-original" style="opacity:.55;">${formatMoney(originalCents)}</s>
        <span class="tryon-total-new" style="font-weight:600;">${formatMoney(Math.max(0, newCents))}</span>
      </span>
    `;
  }

  async function applyTryOnTotalDisplay() {
    const subtotalNodes = findSubtotalNodes().filter(isCartTotalNode);
    if (!subtotalNodes.length) return;

    const cart = await getCart();
    const originalSubtotal = cart.items_subtotal_price ?? cart.total_price ?? 0;

    let tryonSubtotal = 0;

    for (const item of cart.items || []) {
      if (isTryOnItem(item)) {
        tryonSubtotal += item.final_line_price ?? 0;
      }
    }

    if (tryonSubtotal <= 0) {
      subtotalNodes.forEach((node) => {
        if (node.dataset.tryonOriginalHtml) {
          node.innerHTML = node.dataset.tryonOriginalHtml;
        }
      });
      return;
    }

    subtotalNodes.forEach((node) => {
      renderCrossout(node, originalSubtotal, originalSubtotal - tryonSubtotal);
    });
  }

  async function forceTryOnQtyLimit() {
    if (fixingCart) return;

    fixingCart = true;

    try {
      const cart = await getCart();
      let changed = false;

      for (const item of cart.items || []) {
        if (isTryOnItem(item) && item.quantity > 1) {
          await changeCartItem(item.key, 1);
          changed = true;
        }
      }

      if (changed) {
        window.location.reload();
      }
    } catch (error) {
      console.warn("TRY ON quantity limit error:", error);
    }

    fixingCart = false;
  }

  function isTryOnRow(element) {
    const row = element.closest(
      "line-item, cart-line-item, .cart-item, .line-item, [data-line-item], tr"
    );

    if (!row) return null;

    const text = (row.innerText || row.textContent || "").toLowerCase();

    return text.includes(TRYON_TEXT.toLowerCase()) ? row : null;
  }

  function stopTryOnPlusButton(event) {
    const button = event.target.closest("button, a");
    if (!button) return;

    const row = isTryOnRow(button);
    if (!row) return;

    if (button.hasAttribute("data-home-trial-line")) return;

    const label = (
      button.getAttribute("aria-label") ||
      button.getAttribute("name") ||
      button.getAttribute("title") ||
      button.textContent ||
      ""
    ).trim().toLowerCase();

    const isPlus =
      label.includes("increase") ||
      label.includes("plus") ||
      label === "+";

    if (!isPlus) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const input = row.querySelector(
      'input[type="number"], input[name="updates[]"], quantity-input input'
    );

    if (input) {
      input.value = 1;
      input.setAttribute("value", "1");
    }

    return false;
  }

  function scheduleUpdate() {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      applyTryOnTotalDisplay();
      forceTryOnQtyLimit();
    }, 300);
  }

  function hookCartUpdates() {
    applyTryOnTotalDisplay();
    forceTryOnQtyLimit();

    const observer = new MutationObserver(() => {
      applyTryOnTotalDisplay();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener("cart:updated", scheduleUpdate);
    document.addEventListener("cart:refresh", scheduleUpdate);
    document.addEventListener("change", scheduleUpdate, true);

    document.addEventListener("click", stopTryOnPlusButton, true);
    document.addEventListener("pointerdown", stopTryOnPlusButton, true);
    document.addEventListener("touchstart", stopTryOnPlusButton, true);
  }

  document.addEventListener("DOMContentLoaded", hookCartUpdates);
})();